module.exports = __webpack_public_path__ + "img/Plan-de-travail 44@2x-100.8ad5100a.jpg";